import { render, staticRenderFns } from "./actPlace.vue?vue&type=template&id=37c41ebd"
import script from "./actPlace.vue?vue&type=script&lang=js"
export * from "./actPlace.vue?vue&type=script&lang=js"
import style0 from "./actPlace.vue?vue&type=style&index=0&id=37c41ebd&prod&lang=scss"
import style1 from "./actPlace.vue?vue&type=style&index=1&id=37c41ebd&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports